/* =========================================================
   ALMAGI — JS propio (vanilla, sin librerías externas)
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--mt-delay')) {
        el.style.setProperty('--mt-delay', Math.min(i % 6, 5) * 0.08 + 's');
      }
      observer.observe(el);
    });
  }

  /* ---------- Galería de producto: miniatura -> imagen principal ---------- */
  function initGaleriaProducto() {
    var wraps = document.querySelectorAll('[data-mt-galeria]');
    wraps.forEach(function (wrap) {
      var main = wrap.querySelector('[data-mt-galeria-principal]');
      var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!full) return;
          main.src = full;
          main.alt = alt;
          thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activa'); });
          thumb.classList.add('mt-thumb-activa');
        });
      });
    });
  }

  /* ---------- Selector de variantes de producto ---------- */
  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (formWrap) {
      var dataEl = formWrap.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var selects = formWrap.querySelectorAll('[data-mt-opcion]');
      var idInput = formWrap.querySelector('[data-mt-variant-id]');
      var precioEl = formWrap.querySelector('[data-mt-precio]');
      var precioCompareEl = formWrap.querySelector('[data-mt-precio-compare]');
      var botonEl = formWrap.querySelector('[data-mt-add-boton]');
      var textoDisponible = botonEl ? botonEl.getAttribute('data-texto-disponible') : '';
      var textoAgotado = botonEl ? botonEl.getAttribute('data-texto-agotado') : '';

      function moneyFmt(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }

      function actualizar() {
        if (!selects.length) return;
        var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
        var variante = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === seleccion[i]; });
        });
        if (!variante) return;
        if (idInput) idInput.value = variante.id;
        if (precioEl) precioEl.textContent = moneyFmt(variante.price);
        if (precioCompareEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioCompareEl.textContent = moneyFmt(variante.compare_at_price);
            precioCompareEl.hidden = false;
          } else {
            precioCompareEl.hidden = true;
          }
        }
        if (botonEl) {
          botonEl.disabled = !variante.available;
          botonEl.textContent = variante.available ? textoDisponible : textoAgotado;
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  /* ---------- Marquesina infinita (logos / reseñas / frases) ---------- */
  function initMarquesina() {
    var tracks = document.querySelectorAll('[data-mt-marquesina]');
    tracks.forEach(function (track) {
      if (track.dataset.mtDuplicado) return;
      var contenido = track.innerHTML;
      track.innerHTML = contenido + contenido;
      track.dataset.mtDuplicado = 'true';
    });
  }

  /* ---------- Contador animado (count-up) ---------- */
  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var duracion = reduceMotion ? 0 : 1400;
        var inicio = null;
        if (duracion === 0) { el.textContent = fin; obs.unobserve(el); return; }
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.floor(progreso * fin);
          el.textContent = valor.toLocaleString(document.documentElement.lang || 'es');
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString(document.documentElement.lang || 'es');
        }
        requestAnimationFrame(paso);
        obs.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- FAQ desplegable accesible ---------- */
  function initFaq() {
    var items = document.querySelectorAll('[data-mt-faq-pregunta]');
    items.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var abierto = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!abierto));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = abierto;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleriaProducto();
    initVariantes();
    initMarquesina();
    initContadores();
    initFaq();
  });

  /* Reinicializar tras cambios del editor de temas (Shopify) */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initGaleriaProducto();
    initVariantes();
    initMarquesina();
    initContadores();
    initFaq();
  });
})();
